import { render } from "./onBoardActivitiesInfo.vue?vue&type=template&id=0e83eaac&scoped=true&ts=true"
import script from "./onBoardActivitiesInfo.vue?vue&type=script&lang=ts"
export * from "./onBoardActivitiesInfo.vue?vue&type=script&lang=ts"

import "./onBoardActivitiesInfo.vue?vue&type=style&index=0&id=0e83eaac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e83eaac"]])

export default __exports__